<template>
  <DynamicText
    tag="span"
    styleGroup="VS text"
    :get="vsStyle.get"
    :set="vsStyle.set"
    class="vs"
  >
    vs
  </DynamicText>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DynamicText from "../DynamicText.vue";
import { Brand } from "@fresh8/types/src";

export default defineComponent({
  name: "VsText",
  components: {
    DynamicText
  },
  setup() {
    return {
      vsStyle: {
        get: (brand: Brand) => brand.adTemplate.market.teamNameFont,
        set: (brand: Brand, value: string) =>
          (brand.adTemplate.market.teamNameFont = value)
      }
    };
  }
});
</script>

<style></style>
